import { useEffect, useState } from "react";
import { Button, Col, Empty, Row, Table, Tooltip } from "antd";
import {
  LoadingOutlined,
  EditOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { get_language, translate } from "../../locale";
import moment from "moment";
import { TableHelper } from "../../helpers/TableHelper";
import AbTestFormModal from "../Modals/AbTestFormModal";
import AbTestUploader from "../Modals/AbTestUploader";
import AbTestServices from "../../services/AbTestServices";
const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const AbTestTable = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 25,
      total: 0,
    },
    searchText: "",
  });
  const [total, setTotal] = useState(0);
  const [showAddModal, setShowAddModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [uploadModalVisible, setUploadModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const types = {
    feedback_peso: translate("Feedback de peso"),
    configurable_notification: translate("Notificación configurable"),
  };

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      width: 70,
      render: (_, record) => (
        <div className="flex space-x-2">
          <Tooltip title={translate("Editar")}>
            <Button
              onClick={() => {
                setShowAddModal(true);
                setEditData(record);
              }}
              type="text"
              icon={<EditOutlined />}
              size="small"
              className="border-0"
            />
          </Tooltip>
          <Tooltip title={translate("Cargar usuarios (CSV o XLS)")}>
            <Button
              onClick={() => handleFileUpload(record)}
              type="text"
              icon={<UploadOutlined />}
              size="small"
              className="border-0"
            />
          </Tooltip>
        </div>
      ),
    },
    {
      title: translate("Nombre"),
      dataIndex: "name",
      key: "name",
    },
    {
      title: translate("Tipo"),
      dataIndex: "type",
      key: "type",
      render: (_, record) => types[record.type],
    },
    {
      title: translate("Fecha de inicio"),
      dataIndex: "start_date",
      key: "start_date",
      render: (_, record) =>
        moment(record.start_date).format(
          get_language === "es" ? "DD/MM/YYYY" : "MM/DD/YYYY"
        ),
    },
    {
      title: translate("Fecha de fin"),
      dataIndex: "end_date",
      key: "end_date",
      render: (_, record) =>
        moment(record.end_date).format(
          get_language === "es" ? "DD/MM/YYYY" : "MM/DD/YYYY"
        ),
    },
    {
      title: translate("Usuarios"),
      dataIndex: "users",
      key: "users",
      render: (_, record) => (
        <div>
          {translate("Grupo control")}: {record.control_group_count}
          <br />
          {translate("Grupo test")}: {record.test_group_count}
        </div>
      ),
    },
  ];

  useEffect(() => {}, []);

  const handleOnCancelModal = () => {
    setShowAddModal(false);
    setEditData({});
  };

  useEffect(() => {
    loadData();
  }, [JSON.stringify(tableParams), showAddModal]);

  const loadData = async () => {
    setLoading(true);
    let data = {
      page_size: tableParams.pagination.pageSize,
      page_num: tableParams.pagination.current,
    };
    const sorter = TableHelper.sorter(tableParams);
    if (sorter !== null) {
      data = { ...data, order_by: sorter };
    }
    if (tableParams.searchText !== "") {
      data = { ...data, name: tableParams.searchText };
    }
    try {
      const response = await AbTestServices.get(data);
      if (response.status >= 200 && response.status < 300) {
        setData(response.data.abtests);
        setTotal(response.data.total_pages * tableParams.pagination.pageSize);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      sorter,
    });

    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  const handleAdd = () => {
    setShowAddModal(true);
  };

  const handleFileUpload = (record) => {
    setSelectedRecord(record);
    setUploadModalVisible(true);
  };

  const handleUploadCancel = () => {
    setUploadModalVisible(false);
    setSelectedRecord(null);
  };

  const handleUploadSuccess = () => {
    loadData();
  };

  return (
    <>
      <Row gutter={16} className="mb-4">
        <Col className="gutter-row" span="18">
          <div className="text-start">
            <Button
              type="primary"
              className="bg-custom_primary border-custom_primary"
              onClick={handleAdd}
            >
              {translate("Agregar AB test")}
            </Button>
          </div>
        </Col>
      </Row>
      <Table
        rowKey={(i) => {
          return i.id.toString();
        }}
        dataSource={data}
        columns={columns}
        loading={
          loading
            ? { indicator: antIcon, className: "text-custom_blue" }
            : false
        }
        locale={{
          emptyText: <Empty description={translate("No hay datos")} />,
          sortTitle: translate("Ordenar"),
          triggerDesc: translate("Ordenar (descendente)"),
          triggerAsc: translate("Ordenar (ascendente)"),
          cancelSort: translate("Cancelar orden"),
        }}
        pagination={{ ...tableParams.pagination, total: total }}
        onChange={handleTableChange}
      />

      <AbTestFormModal
        visible={showAddModal}
        onCancel={handleOnCancelModal}
        onComplete={handleOnCancelModal}
        editData={editData}
      />

      <AbTestUploader
        visible={uploadModalVisible}
        onCancel={handleUploadCancel}
        onSuccess={handleUploadSuccess}
        record={selectedRecord}
      />
    </>
  );
};

export default AbTestTable;
